import React from 'react';
import { Check, Star } from 'lucide-react';

const st = (i) => ({ '--i': i });

export const Row = ({ i = 0, initials, title, sub, tag, tone = 'gris', icon }) => <div className="dm-row d-in" style={st(i)}>
  {icon ? <span className="dm-ico">{icon}</span> : initials ? <span className="dm-avatar">{initials}</span> : null}
  <span className="dm-txt"><b>{title}</b>{sub && <small>{sub}</small>}</span>
  {tag && <span className={`kit-tag is-${tone} dm-tag`}>{tag}</span>}
</div>;

export const Line = ({ w = 80, i = 0, dark = false }) => <span className={`dm-line d-in ${dark ? 'is-dark' : ''}`} style={{ ...st(i), width: `${w}%` }} />;

export const Chip = ({ i = 0, tone = 'gris', children }) => <span className={`kit-tag is-${tone} d-in`} style={st(i)}>{children}</span>;

export const Bar = ({ i = 0, value = 70, label, right }) => <div className="dm-bar d-in" style={{ ...st(i), '--v': `${value}%` }}>
  <span className="dm-bar-l"><b>{label}</b>{right && <em>{right}</em>}</span>
  <span className="dm-bar-t"><span className="dm-bar-f" /></span>
</div>;

export const Typing = ({ i = 0, children }) => <p className="dm-type d-in" style={st(i)}><span>{children}</span></p>;

export const Big = ({ i = 0, title, sub, icon }) => <div className="dm-big d-in" style={st(i)}>
  <span className="dm-big-ico d-pop" style={st(i)}>{icon || <Check size={26} strokeWidth={3} />}</span>
  <b>{title}</b>{sub && <small>{sub}</small>}
</div>;

export const Stars = ({ i = 0, n = 5 }) => <span className="dm-stars d-in" style={st(i)}>{Array.from({ length: 5 }, (_, k) => <Star key={k} size={13} className={k < n ? 'is-on' : ''} />)}</span>;

export const Toggle = ({ i = 0, label, sub }) => <div className="dm-row d-in" style={st(i)}>
  <span className="dm-txt"><b>{label}</b>{sub && <small>{sub}</small>}</span>
  <span className="dm-toggle d-on" style={st(i)}><i /></span>
</div>;

export const Bubble = ({ i = 0, me = false, children }) => <div className={`dm-bubble d-in ${me ? 'is-me' : ''}`} style={st(i)}>{children}</div>;

export const Cal = ({ i = 0, days = ['L', 'M', 'M', 'J', 'V'], on = 1, label }) => <div className="dm-cal d-in" style={st(i)}>
  {days.map((d, k) => <span key={k} className={k === on ? 'is-on' : ''}>{d}<i>{9 + k}</i></span>)}
  {label && <em className="d-in" style={st(i + 2)}>{label}</em>}
</div>;

export const Photos = ({ i = 0, n = 3 }) => <div className="dm-photos">{Array.from({ length: n }, (_, k) => <span key={k} className={`d-in t${k % 3}`} style={st(i + k)} />)}</div>;

export const Stat = ({ i = 0, label, value, delta }) => <div className="dm-stat d-in" style={st(i)}><small>{label}</small><b>{value}</b>{delta && <em>{delta}</em>}</div>;

export const Btn = ({ i = 0, done, children }) => <span className={`dm-btn d-in ${done ? 'is-done' : ''}`} style={st(i)}>{done && <Check size={12} strokeWidth={3} />}{children}</span>;

export const Screen = ({ children, title }) => <div className="dm-screen">{title && <span className="dm-screen-t">{title}</span>}{children}</div>;
